var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4022_692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "url(#paint0_linear_4022_692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.3066C8.37849 10.3066 10.3066 8.37849 10.3066 6C10.3066 3.62151 8.37849 1.69336 6 1.69336C3.62151 1.69336 1.69336 3.62151 1.69336 6C1.69336 8.37849 3.62151 10.3066 6 10.3066Z",
    fill: "url(#paint1_linear_4022_692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99994 10.3066C8.37843 10.3066 10.3066 8.37849 10.3066 6C10.3066 3.62151 8.37843 1.69336 5.99994 1.69336C3.62145 1.69336 1.6933 3.62151 1.6933 6C1.6933 8.37849 3.62145 10.3066 5.99994 10.3066Z",
    stroke: "url(#paint2_linear_4022_692)",
    strokeOpacity: 0.65,
    strokeWidth: 0.7575,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99939 10.9813C8.9839 10.5828 9.82697 9.89937 10.4206 9.01863C11.0141 8.13788 11.3312 7.09994 11.331 6.03784",
    stroke: "#F1E39F",
    strokeWidth: 0.454453,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33417 1.38286C4.14422 0.913873 5.06393 0.66757 5.99995 0.668951",
    stroke: "#F0E09B",
    strokeWidth: 0.454453,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.51801 3.11145C1.77765 2.70924 2.09013 2.34371 2.44707 2.02466",
    stroke: "#F0E09B",
    strokeWidth: 0.454453,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31758 8.55094C0.890687 7.76854 0.667584 6.89128 0.668828 6",
    stroke: "#F0E09B",
    strokeWidth: 0.454453,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11398 5.57028L6.06281 4.04895C6.05581 4.03875 6.04644 4.03041 6.0355 4.02464C6.02455 4.01888 6.01237 4.01587 6 4.01587C5.98763 4.01587 5.97545 4.01888 5.9645 4.02464C5.95356 4.03041 5.94418 4.03875 5.93719 4.04895L4.88602 5.57028C4.87595 5.58495 4.86107 5.59565 4.84395 5.60053C4.82684 5.60541 4.80856 5.60416 4.79227 5.597L3.3007 4.93442C3.28739 4.92857 3.27268 4.92663 3.2583 4.92883C3.24392 4.93102 3.23046 4.93727 3.2195 4.94683C3.20854 4.95639 3.20052 4.96887 3.19639 4.98282C3.19226 4.99677 3.19219 5.0116 3.19617 5.02559L4.06102 7.98715C4.06563 8.00304 4.07528 8.017 4.08851 8.02693C4.10174 8.03686 4.11783 8.04223 4.13437 8.04223H7.86586C7.8824 8.04223 7.8985 8.03686 7.91172 8.02693C7.92495 8.017 7.9346 8.00304 7.93922 7.98715L8.80406 5.02559C8.80805 5.0116 8.80797 4.99677 8.80384 4.98282C8.79971 4.96887 8.79169 4.95639 8.78073 4.94683C8.76977 4.93727 8.75631 4.93102 8.74193 4.92883C8.72756 4.92663 8.71285 4.92857 8.69953 4.93442L7.20797 5.597C7.19163 5.60408 7.17334 5.60529 7.1562 5.60042C7.13907 5.59555 7.12415 5.5849 7.11398 5.57028Z",
    fill: "#F2E4A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4022_692",
    x1: 6.00015,
    y1: 12.5457,
    x2: 6.00015,
    y2: -1.32451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D17713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4022_692",
    x1: 6.00011,
    y1: 10.6983,
    x2: 6.00011,
    y2: 0.742664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D17713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4022_692",
    x1: 6.00005,
    y1: 10.6983,
    x2: 6.00005,
    y2: 0.742664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D17713"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4022_692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredits);
export default __webpack_public_path__ + "static/media/credits.bc4f8e7c01ba2667b8d6fa5c877d9cc2.svg";
export { ForwardRef as ReactComponent };